export const ChartUtils = [
  { id: 'alto', value: "Alto", name: "Alto", range: {min: '0', max: '199'} },
  { id: 'medioAlto', value: "Medio Alto", name: "Medio Alto", range: {min: '200', max: '399'} },
  { id: 'medio', value: "Medio", name: "Medio", range: {min: '400', max: '599'} },
  { id: 'medioBajo', value: "Medio Bajo", name: "Medio Bajo", range: {min: '600', max: '799'} },
  { id: 'bajo', value: "Bajo", name: "Bajo", range: {min: '800', max: '999'} }
];
